module.exports = __webpack_public_path__ + "img/Header_My_Left.a10db4cd.svg";